// extracted by css-extract-rspack-plugin
export default {"container":"qq0ylOsiINFc2YsV","valueContainer":"SEp4LdxmuRYKSotV","label":"hYMlikw7jwub_dz9","title":"osaaBtiWpcgTlWnu","value":"nXGqjjdrNu8GgR1u"};